var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagEn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 400,
    viewBox: "0 0 600 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_568_1133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600 0H0V400H600V0Z",
    fill: "#0A17A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 145H600V255H0V145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245 0H355V400H245V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L600 400Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L600 400",
    stroke: "white",
    strokeWidth: 62
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 0L0 400Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 0L0 400",
    stroke: "white",
    strokeWidth: 62
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L600 400Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L600 400",
    stroke: "#C8102E",
    strokeWidth: 26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 0H330V400H270V0Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 170H600V230H0V170Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 0L0 400Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 0L0 400",
    stroke: "#C8102E",
    strokeWidth: 26
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_568_1133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 400,
    rx: 43,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEn);
export default __webpack_public_path__ + "static/media/flag_en.39ca6b5e299fca0c00ce68c69bc60219.svg";
export { ForwardRef as ReactComponent };